import { actionHandlerWithFeatureFlag } from 'utils';
import { FEATURE_FLAGS } from 'utils/constants';
import {
  msFetchManagementLevels,
  msInsertOrUpdateLevel,
  msRemoveLevel,
} from 'services/SchoolConfigService';
import SkRequest from './BaseRequest';
import { QueryBuilder, MutationBuilder } from '../queryBuilder';
import { FETCH_ALL_MANAGEMENT_LEVELS } from './actionTypes';

import localstorage from '../../utils/localStorage';
import DatadogHandler from '../../utils/datadog';

const _mQueryBuilder = new QueryBuilder();
const _mMutationBuilder = new MutationBuilder();
const fileName = 'src/redux/actions/Levelmanagement.js';

const lvlResp = {
  ID: 'number',
  label: 'String',
  fromMonth: 'number',
  toMonth: 'number',
  promotionDate: 'date',
  updatedAt: 'datetime',
  offOnSaturday: 'boolean',
  isInfant: 'boolean',
  reservePromotionSeatFrom: 'number',
  reservePromotionSeatTo: 'number',
};

_mQueryBuilder.setNewQuery('getLevelsForSchool', {
  data: lvlResp,
});

_mMutationBuilder.setNewMutation('insertOrUpdateLevelForSchool', lvlResp);

_mMutationBuilder.setNewMutation('removeLevelForSchool', {});

const dispatchManagementLevelFetch = (
  dispatch,
  inProgress = true,
  data = {},
  error = null
) => {
  dispatch({
    type: FETCH_ALL_MANAGEMENT_LEVELS,
    key: 'managementLevels',
    value: {
      inProgress,
      data,
      error,
    },
  });
};

export const monoRemoveLevel = async (_, reqData) => {
  try {
    const { IDSchool, levelID } = reqData;
    const data = await SkRequest({
      authToken: localstorage.getValue('userToken'),
      data: {
        query: _mMutationBuilder.getMutationAsString('removeLevelForSchool', {
          IDSchool,
          levelID,
        }),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoRemoveLevel',
      },
      'error'
    );
    throw ex;
  }
};

export const removeLevel = async (IDSchool, levelID) => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msRemoveLevel,
        monoHandler: monoRemoveLevel,
        extraData: { IDSchool, levelID },
      }
    );

    return data;
  } catch (ex) {
    throw ex;
  }
};

export const monoInsertOrUpdateLevel = async (_, reqData) => {
  try {
    const { IDSchool, levelData, levelID = 0 } = reqData;
    const saveData = { IDSchool, levelID, levelData };
    if (!levelID) {
      delete saveData.levelID;
    }

    const data = await SkRequest({
      authToken: localstorage.getValue('userToken'),
      data: {
        query: _mMutationBuilder.getMutationAsString(
          'insertOrUpdateLevelForSchool',
          saveData
        ),
      },
      method: 'POST',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoInsertOrUpdateLevel',
      },
      'error'
    );
    throw ex;
  }
};

export const createOrUpdateLevel = async (IDSchool, levelData, levelID = 0) => {
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        msHandler: msInsertOrUpdateLevel,
        monoHandler: monoInsertOrUpdateLevel,
        extraData: { IDSchool, levelData, levelID },
      }
    );

    return data;
  } catch (ex) {
    throw ex;
  }
};

export const monoFetchManagementLevels = (_, reqData) => {
  try {
    return SkRequest({
      authToken: localstorage.getValue('userToken'),
      data: {
        query: _mQueryBuilder.getQueryAsString('getLevelsForSchool', reqData),
      },
      method: 'POST',
    });
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoFetchManagementLevels',
      },
      'error'
    );
    return { error: [{ message: ex.message }] };
  }
};

export const fetchManagementLevels =
  (IDSchool, pagination = {}, filter = {}) =>
  async dispatch => {
    dispatchManagementLevelFetch(dispatch);
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchManagementLevels,
        monoHandler: monoFetchManagementLevels,
        extraData: { IDSchool, pagination, filter },
      }
    );

    if (data.success) {
      dispatchManagementLevelFetch(dispatch, false, data);
    } else {
      dispatchManagementLevelFetch(dispatch, false, null, data.error);
    }

    return data;
  };

export default fetchManagementLevels;
